import { z } from "zod";

export const ScoreBucketGranularities = ["whole", "half", "quarter"] as const;
export const ScoreBucketGranularitySchema = z.enum(ScoreBucketGranularities);
export type ScoreBucketGranularity = z.infer<typeof ScoreBucketGranularitySchema>;

export const DEFAULT_SCORE_BUCKET_GRANULARITY: ScoreBucketGranularity = "whole";

const BUCKETS: Record<ScoreBucketGranularity, { width: number; boundaryFractionDigits: number }> = {
    whole: { width: 1, boundaryFractionDigits: 1 },
    half: { width: 0.5, boundaryFractionDigits: 2 },
    quarter: { width: 0.25, boundaryFractionDigits: 3 }
};

export function getBucketWidth(granularity: ScoreBucketGranularity): number {
    return BUCKETS[granularity].width;
}

export function getBoundaryFractionDigits(granularity: ScoreBucketGranularity): number {
    return BUCKETS[granularity].boundaryFractionDigits;
}

export function getPointFractionDigits(granularity: ScoreBucketGranularity): number {
    return getBoundaryFractionDigits(granularity) - 1;
}

export function getBucketCount(maxScale: number, granularity: ScoreBucketGranularity): number {
    return Math.round((maxScale - 1) / getBucketWidth(granularity)) + 1;
}

export function getBucketPoints(maxScale: number, granularity: ScoreBucketGranularity): number[] {
    const width = getBucketWidth(granularity);

    return Array.from({ length: getBucketCount(maxScale, granularity) }, (_, index) => 1 + index * width);
}
